const module = { name: 'video/redbandAutoshow.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as redbandVerification } from 'swug-fdRequire-call:video/redbandVerification';

function run() {
    checkDependencies(module.name, debugLog);
    redbandVerification.init();
    redbandVerification.showAgeModal();
}
run();
export default module.exports;